//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';

import { Caption } from '@components/atoms/caption/Caption';
import { SocialNetwork } from '@models/SocialNetwork';
import { UIACaptionLink } from '@uia/details/captions/UIACaptionLink';

export interface UIACaptionProps {
  caption: string;
  socialNetwork: SocialNetwork;
}

export const UIACaption = ({ caption, socialNetwork }: UIACaptionProps) => (
  <Caption
    caption={caption}
    customTextDecorator={(text) => UIACaptionLink({ text, socialNetwork })}
    shouldDecorateLinks={true}
    socialNetwork={socialNetwork}
  />
);
